// src/App.js
import React from "react";
import CategoryForm from "./CategoryForm";
import CategoryList from "./CategoryList";
import OneTimeExecution from "./OneTimeExecution";
import { useCheckAccess } from "../../utils/Utilities";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
const CategoryAdmin = () => {
    useCheckAccess('ConfigRW,SuperUser');
    const user = useSelector((state) => state.user);
    return (
        <>
            <Navbar />
            <Helmet>
                <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | Category Form</title>
                <link rel="canonical" href="/family/create" />
            </Helmet>
            <Breadcrumbs /><br />
            <>
                {user?.roles?.includes('ConfigRW') && (
                    <>
                        <CategoryForm />
                        <CategoryList />
                    </>
                )}

                {
                    user.roles && ['SuperUser', 'StatementsRO'].some(role => user.roles.includes(role))
                    && (
                        <div className="general_parent">
                            <div className="general_container">
                                <div className="general_body">
                                    <OneTimeExecution />
                                </div>
                            </div>
                        </div>
                    )
                }
            </>
            <Footer/>
        </>
    );
}

export default CategoryAdmin;
